import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Wrapper from "../../timvir/wrapper";
const MDXLayout = Wrapper;
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    hr: "hr",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Getting Started"
    }), "\n", _jsx(_components.hr, {}), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#try-timvir-online",
          children: "Try Timvir online"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#add-timvir-to-an-existing-project",
          children: "Add Timvir to an existing project"
        })
      }), "\n"]
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h2, {
      children: "Try Timvir online"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "http://codesandbox.io/s/github/timvir/template",
        children: "Open the Timvir Template in CodeSandbox"
      }), " and start editing right away! This is the quickest way to discover what Timvir is and what you can do with it."]
    }), "\n", _jsx(_components.h2, {
      children: "Add Timvir to an existing project"
    }), "\n", _jsx(_components.p, {
      children: "If you have an existing project and want to add Timvir to it, follow one these guides which are specific to the framework which you use:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#nextjs",
          children: "Next.js"
        })
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Next.js"
    }), "\n", _jsx(_components.p, {
      children: "Timvir assumes a very specific setup of your Next.js project. In particular:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Source must be placed into the ", _jsx(_components.code, {
          children: "src/"
        }), " folder, and consequently, pages are placed in ", _jsx(_components.code, {
          children: "src/pages/"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Your components are placed into ", _jsx(_components.code, {
          children: "src/components/"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Timvir assumes management of the ", _jsx(_components.code, {
          children: "src/pages/docs/components/"
        }), " folder."]
      }), "\n", _jsxs(_components.li, {
        children: ["Timvir specific integration code is placed into ", _jsx(_components.code, {
          children: "src/timvir/"
        }), " (eg. ", _jsx(_components.code, {
          children: "src/timvir/toc.ts"
        }), ")."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "If you Next.js project has a compatible setup, follow these steps:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Add ", _jsx(_components.a, {
          href: "https://mdxjs.com/getting-started/next",
          children: "mdxjs"
        }), " support into your project."]
      }), "\n", _jsxs(_components.li, {
        children: ["Create a page wrapper. Copy the following code into ", _jsx(_components.code, {
          children: "src/timvir/wrapper.tsx"
        }), ":"]
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        children: "import Link from \"next/link\";\nimport { useRouter } from \"next/router\";\nimport * as React from \"react\";\nimport { Page } from \"timvir/core\";\n\nexport default ({ children }: { children?: React.ReactNode }) => (\n  <Page location={useRouter()} Link={Link} toc={[]}>\n    {children}\n  </Page>\n);\n"
      })
    }), "\n", _jsxs(_components.ol, {
      start: "3",
      children: ["\n", _jsxs(_components.li, {
        children: ["Create (or update) your ", _jsx(_components.code, {
          children: "_app.tsx"
        }), " file to load the Timvir CSS:"]
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        children: "import App from \"next/app\";\nimport \"timvir/core/styles.css\";\nexport default App;\n"
      })
    }), "\n", _jsxs(_components.ol, {
      start: "4",
      children: ["\n", _jsxs(_components.li, {
        children: ["Create your first Timvir page. Place the following code into ", _jsx(_components.code, {
          children: "src/pages/docs/index.mdx"
        }), ":"]
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        children: "import Wrapper from \"../../timvir/wrapper\";\nexport default Wrapper\n\n# My First Timvir Page\n"
      })
    }), "\n", _jsxs(_components.ol, {
      start: "5",
      children: ["\n", _jsx(_components.li, {
        children: "Open http://localhost:3000/docs/ to view the page you just created."
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  return _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  });
}
